const mapping: Record<string, string> = {
  id: 'l=>l.Id',
  name: 'p=>p.Name',
  active: 'p=>p.Active',
}

export const mapSortVariantParam = (key: string) => mapping[key]
